import {
  successPageBarcelonaStyling,
  orderDetailsStyling,
  paymentDetailsStyling,
} from "@made-people/blueprint-success-page/blueprint";

successPageBarcelonaStyling.override({
  slots: {
    base: "lg:max-w-[800px] lg:p-[5.6rem] mx-4 lg:mx-auto my-12 lg:my-[4rem] lg:py-[3.5rem] flex flex-col bg-white lg:border lg:border-border-light lg:rounded-[0.4rem]",
    heading:
      "text-heading-md lg:text-heading-md font-secondary mb-4 lg:mb-8 text-center",
    orderNumberLabel: "text-body-sm lg:text-body-md text-center",
    orderNumber:
      "text-heading-xs font-bold lg:text-body-lg lg:font-bold mb-4 text-center",
    body: "text-body-sm lg:text-body-md text-center lg:mb-[3.5rem]",
    button: "hidden",
    cartSummaryWrapper:
      "lg:col-start-2 lg:row-start-2 row-span-10 lg:mt-0 mt-12 mb-6",
    cartSummaryHeading: "text-body-lg font-bold text-center mb-6",
    hiddenLabel: "sr-only",
  },
});

orderDetailsStyling.override({
  slots: {
    base: "flex flex-col gap-1 pb-6",
    row: "flex flex-row justify-between text-body-sm lg:text-body-md",
    label: "",
    item: "text-right",
    hiddenLabel: "sr-only",
  },
});

paymentDetailsStyling.override({
  slots: {
    base: "flex flex-col gap-1 py-6 border-t border-border-light",
    row: "flex flex-row justify-between text-body-sm lg:text-body-md data-[label='total']:text-body-lg data-[label='total']:font-bold ",
    label: "",
    item: "text-right",
    hiddenLabel: "sr-only",
  },
});
